import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { UserRole } from "@jugl-web/rest-api";
import { CXAIAgentsPage } from "./CXAIAgentsPage/CXAIAgentsPage";
import { CXAnalyticsPage } from "./CXAnalyticsPage/CXAnalyticsPage";
import { CXWorkspaceGeneralPage } from "./CXWorkspaceGeneralPage";
import { CXWorkspacePlansPage } from "./CXWorkspacePlansPage";
import { CXTrialPage } from "./CXTrialPage";
import { CXWorkspaceTeamPage } from "./CXWorkspaceTeamPage";
import { CXWorkspaceMyAccountPage } from "./CXWorkspaceMyAccountPage";
import { CXWorkspaceNotificationsPage } from "./CXWorkspaceNotificationsPage";
import { CXLoginPage } from "./CXLoginPage";
import { CXOnboardingPage } from "./CXOnboardingPage";
import { CXActionsFormPage } from "./CXActionsFormPage";

export type CXPagesNavigationParams = {
  cxTrial: PageNavParams;
  cxAIAgents: PageNavParams;
  cxAnonymousAIAgents: PageNavParams;
  cxAnalytics: PageNavParams;
  cxWorkspaceGeneral: PageNavParams;
  cxWorkspacePlans: PageNavParams;
  cxWorkspaceTeam: PageNavParams;
  cxWorkspaceMyAccount: PageNavParams;
  cxWorkspaceNotifications: PageNavParams;
  cxLogin: PageNavParams;
  cxOnboarding: PageNavParams<never, { flow?: string }>;
  cxActionsForm: PageNavParams;
};

export const cxPagesNavigationConfig: ModulePagesConfig<CXPagesNavigationParams> =
  {
    cxTrial: {
      element: <CXTrialPage />,
      path: "cx/trial",
      isEntityOptional: true,
      isPrivate: true,
      isAnonymousAllowed: true,
      isNavigationHidden: true,
      isSideBarHidden: true,
    },
    cxAnonymousAIAgents: {
      element: <CXAIAgentsPage />,
      path: "cx/anonymous/ai-agents",
      isPrivate: true,
      isAnonymousAllowed: true,
    },
    cxAIAgents: {
      element: <CXAIAgentsPage />,
      path: "cx/ai-agents",
      isPrivate: true,
    },
    cxAnalytics: {
      element: <CXAnalyticsPage />,
      path: "cx/analytics",
      isPrivate: true,
    },
    cxActionsForm: {
      element: <CXActionsFormPage />,
      path: "cx/actions/form",
      isPrivate: true,
    },
    cxWorkspaceGeneral: {
      element: <CXWorkspaceGeneralPage />,
      path: "cx/settings/general",
      isPrivate: true,
      isSideBarHidden: true,
      requiredUserRoles: [UserRole.admin],
    },
    cxWorkspacePlans: {
      element: <CXWorkspacePlansPage />,
      path: "cx/settings/plans",
      isPrivate: true,
      isSideBarHidden: true,
      requiredUserRoles: [UserRole.admin],
    },
    cxWorkspaceTeam: {
      element: <CXWorkspaceTeamPage />,
      path: "cx/settings/team",
      isPrivate: true,
      isSideBarHidden: true,
      requiredUserRoles: [UserRole.admin],
    },
    cxWorkspaceMyAccount: {
      element: <CXWorkspaceMyAccountPage />,
      path: "cx/settings/my-account",
      isPrivate: true,
      isSideBarHidden: true,
    },
    cxWorkspaceNotifications: {
      element: <CXWorkspaceNotificationsPage />,
      path: "cx/settings/notifications",
      isPrivate: true,
      isSideBarHidden: true,
    },
    cxLogin: {
      element: <CXLoginPage />,
      path: "/cx/login",
      isPrivate: false,
      isNavigationHidden: true,
      isSideBarHidden: true,
    },
    cxOnboarding: {
      element: <CXOnboardingPage />,
      path: "/cx/onboarding",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: true,
      isNavigationHidden: true,
      isSideBarHidden: true,
    },
  };
